import { PlaceData } from '../enums/maps';
import { BaseModel } from './base';
import { Submission } from './submission';


export interface Project extends BaseModel {
    submissionId: ModelId | null,
    client: string;
    tel: string,
    email: string,
    emplacement: string | PlaceData,
    description: string,
    created: string | null;
    files: number[] | null;
    franchiseId: number | null,
    debutTravaux: string | null,
    price: number | null,
    paid: number | null,
    notes: string | null;
}

export const newProject: Project = {
    id: 0,
    submissionId: null,
    client: '',
    tel: '',
    email: '',
    emplacement: '',
    description: '',
    created: null,
    files: [],
    franchiseId: null,
    debutTravaux: null,
    price: null,
    paid: null,
    notes: null
};

export const newProjectFromSubmission = (submission: Submission): Project => {
    return {
        ...newProject,
        submissionId: submission.id,
        client: submission.name,
        tel: submission.tel,
        email: submission.email,
        emplacement: submission.emplacement,
        description: submission.description,
        files: submission.files,
        debutTravaux: submission.debutTravaux,
    };
};
